import React, { useEffect, useRef } from "react"
import LocalsMenu from "./localsMenu.json"
import i18n from "../utils/i18n"
import constants from "../constants"
import { gsap } from "gsap"
import Actions from "../actions"

const StoryTopInfo = ({ state=`close`, className, id, lang }) => {
  const parent = useRef()
  // const [ isMouseOver, setIsMouseOver ] = useState(false)
  useEffect(() => {
    const w = parent.current.offsetWidth + 50
    gsap.set(parent.current, { x: w, opacity: 1 })
  }, [])
  useEffect(() => {
    const w = parent.current.offsetWidth + 50
    gsap.to(parent.current, { x: state === `open` ? 0 : w, duration: 0.6, delay: 0.6, opacity: 1,  ease: state === `open` ? `expo.out` : `expo.in` })
  })
  const onClick = () => {
    setTimeout(Actions.openLookbook)
  }
  return (
    <div ref={parent} className={`${className} opacity-0`}>
      <div className={`relative flex flex-col items-center`}>
        <div className={`bg-transparent text-black border-2 border-black inline-flex items-center px-5 lg:px-7 lg:pb-1 h-11 lg:h-16 ${constants.heading} rounded-full`}>
          <div className={`relative lg:top-0.5`}>{i18n(LocalsMenu, `title-${id}`, lang)}</div>
        </div>
        <button onClick={onClick} style={{ outline: 0 }} className={`inline-block mt-2 lg:mt-1 border-b border-black ${constants.paragraph2}`}>{`${i18n(LocalsMenu, `title-view`, lang)}`}</button>
      </div>
    </div>
  )
}

export default StoryTopInfo